module.exports = __webpack_public_path__ + "61282808e613b96e8c0256b41f9f195e.jpg";